import { useMemo } from 'react';
import { IBooleanCondition } from '../../../inputs';
import { useExpressionsValues } from '../../expressions/render/hooks/useExpressionsValues';
import { conditionResultToBoolean } from './conditionResultToBoolean';
import { IUseBooleanConditionOptions } from './useBooleanCondition';

/**
 * Gestisce un array di condizioni booleane, come `useBooleanCondition` ma
 * per più condizioni.
 */
export function useBooleanConditions(
  conditions: Array<IBooleanCondition | null | undefined>,
  options: IUseBooleanConditionOptions,
) {
  const allConditions = useMemo(
    () => conditions.map(c => (c?.type === 'expression' ? c.expression : null)),
    [conditions],
  );

  const expressionsValues = useExpressionsValues(options.name, allConditions);

  return useMemo(() => {
    return conditions.map((condition, index) => {
      const result = {
        condition,
        result:
          Boolean(options.preview) || options.skip
            ? true
            : conditionResultToBoolean(condition, expressionsValues[index]),
      };

      return result;
    });
  }, [conditions, expressionsValues, options.preview, options.skip]);
}
